var SessionPropertiesEventType = {
    OPEN : 0,
    UPDATE : 1,
    CLOSE : 2
};

module.exports = SessionPropertiesEventType;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/session-properties-event-type.js
// module id = 726
// module chunks = 1